<router-outlet></router-outlet>
<tour-step-template>
  <ng-template let-step="step">
    <mat-card (click)="$event.stopPropagation()">
      <mat-card-title class="p-2">
        <span class="title-text">{{ step?.title | translate }}</span>
        <i class="material-icons title-close" (click)="endTour()">close</i>
      </mat-card-title>
      <mat-card-content class="p-2">
        {{ step?.content | translate }}
      </mat-card-content>
      <mat-card-actions
        *ngIf="step?.nextBtnTitle || step?.endBtnTitle || step?.customButton"
        class="p-2 justify-content-end"
      >
        <button
          type="button"
          class="prev-button btn btn-ghost mr-auto"
          [hidden]="!step?.customButton"
          (click)="step?.customButton()"
        >
          {{ step?.customButtonTitle | translate }}
        </button>
        <button
          type="button"
          class="next-button btn btn-success"
          [hidden]="!step?.nextBtnTitle"
          (click)="nextTour()"
        >
          {{ step?.nextBtnTitle | translate }}
        </button>
        <button
          type="button"
          class="next-button btn btn-success"
          (click)="step?.customEndButton ? step?.customEndButton() : endTour()"
          [hidden]="!step?.endBtnTitle && !step?.customEndButton"
        >
          {{ step?.endBtnTitle | translate }}
        </button>
      </mat-card-actions>
    </mat-card>
  </ng-template>
</tour-step-template>
